export default __webpack_public_path__ + "static/media/laundry2-afterB-480w.7ec11d95.webp";